"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgCart = function (props) {
    var color = props.color;
    return (react_1.default.createElement("path", { fill: color, fillRule: "evenodd", d: "M5.08 4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 .997.917L7.253 6H21a1 1 0 0 1 .97 1.243l-1.621 6.485A3 3 0 0 1 17.439 16H8.84a3 3 0 0 1-2.99-2.75L5.08 4zm2.34 4l.424 5.083A1 1 0 0 0 8.84 14h8.598a1 1 0 0 0 .97-.757L19.72 8H7.42zM8 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm8 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" }));
};
exports.default = factorySvgIcon_1.default(SvgCart);
//# sourceMappingURL=SvgCart.js.map